import { action, makeObservable, observable } from 'mobx';
import { gameResultStore } from '@pascal/pascal-core/shared/core/store';
import { CARDS } from '../enums/cardTypes';
import { soundService, soundTypes } from '../services/SoundService';
import { AWAY_CARD, HOME_CARD } from '../enums/cardOwner';

class CardsStore {
  homeCard = {};

  awayCard = {};

  burnedCards = [];

  openedCardsCount = null;

  currentCardPoint = null;

  bankerTotalPoints = null;

  playerTotalPoints = null;

  cuttingCardPlace = null;

  selectedCardType = 'calode-1';

  selectedCardBackSideType = 'backside-1';

  isCuttingCardOpen = false;

  isShuffle = false;

  shuffleAnimationType = '';

  burnedCardsCount = 0;

  constructor() {
    makeObservable(this, {
      homeCard: observable.deep,
      awayCard: observable.deep,
      burnedCards: observable.deep,
      selectedCardType: observable,
      burnedCardsCount: observable,
      selectedCardBackSideType: observable,
      isShuffle: observable,
      shuffleAnimationType: observable,
      currentCardPoint: observable,
      bankerTotalPoints: observable,
      playerTotalPoints: observable,
      cuttingCardPlace: observable,
      openedCardsCount: observable,
      isCuttingCardOpen: observable,
      resetCardsInfo: action.bound,
      setTableCards: action.bound,
      updateTableCards: action.bound,
      setCurrentCardPoint: action.bound,
      setBurnedCards: action.bound,
      setBurnedCardsCount: action.bound,
      updateBurnedCards: action.bound,
      setBankerTotalPoints: action.bound,
      setPlayerTotalPoints: action.bound,
      setCuttingCardPlace: action.bound,
      setSelectedCardType: action.bound,
      setSelectedCardBackSideType: action.bound,
      setOpenedCardsCount: action,
      setIsCuttingCardOpen: action.bound,
      setIsShuffle: action.bound,
      setShuffleAnimationType: action.bound,
    });
  }

  setSelectedCardType(type) {
    this.selectedCardType = type;
  }

  setIsShuffle(bool) {
    this.isShuffle = bool;
  }

  setShuffleAnimationType(type) {
    this.shuffleAnimationType = type;
  }

  setBurnedCardsCount(count) {
    this.burnedCardsCount = count;
  }

  setSelectedCardBackSideType(type) {
    this.selectedCardBackSideType = type;
  }

  setOpenedCardsCount(count) {
    this.openedCardsCount = count;
  }

  setCurrentCardPoint(arg) {
    this.currentCardPoint = arg;
  }

  setBankerTotalPoints(arg) {
    this.bankerTotalPoints = arg;
  }

  setPlayerTotalPoints(arg) {
    this.playerTotalPoints = arg;
  }

  setCuttingCardPlace(arg) {
    this.cuttingCardPlace = arg;
  }

  setTableCards(arg) {
    soundService.play(soundTypes.Card);
    this.userCards = arg;
  }

  setBurnedCards(burnedCards) {
    this.burnedCards = burnedCards;
  }

  updateBurnedCards(burnedCard) {
    this.burnedCards = [...this.burnedCards, burnedCard];
  }

  setIsCuttingCardOpen(arg) {
    this.isCuttingCardOpen = arg;
  }

  updateTableCards(card) {
    this.openedCardsCount += 1;
    if (card.card === CARDS.CUTTING_CARD) {
      this.setIsCuttingCardOpen(true);
    }
    const results = [...gameResultStore.gameResults];
    const cardIndex = results.findIndex((item) => item.index === card.index);
    if (cardIndex > -1) {
      results.splice(cardIndex, 1, card);
      gameResultStore.setGameResults(results);
    }
    if (card.side === HOME_CARD && card.card !== CARDS.CUTTING_CARD) {
      this.homeCard = card;
    } else if (card.side === AWAY_CARD && card.card !== CARDS.CUTTING_CARD) {
      this.awayCard = card;
    }
  }

  resetCardsInfo() {
    this.homeCard = [];
    this.awayCard = [];
  }
}

export const cardsStore = new CardsStore();
